import ImageGallery from "react-image-gallery";
import { images } from "./constants";
import "./gallery-page.scss";

type GalleryPageProps = { startIndex?: number };

const GalleryPage = (props: GalleryPageProps) => {
  return (
    <>
      <div className="page">
        <div className="gallery-title page__header">
          <h1 className="page__header__title">ГАЛЕРИЯ</h1>
        </div>
        <ImageGallery
          items={images}
          thumbnailPosition="left"
          showBullets={true}
          showPlayButton={false}
          additionalClass="gallery"
          startIndex={props.startIndex || 0}
        />
      </div>
    </>
  );
};

export default GalleryPage;
